import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux'; 


const AuthorProfileForm = () => {
  const authState = useSelector(state => state.authReducer);
  const [submitstatus, setSubmitstatus] = useState('');
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [dealCode, setDealCode] = useState('1234567890');
  const [formData, setFormData] = useState({
    businessName: '',
    businessCode: '',
    contactEmail: '',
    phone: '',
    website: '',
    businessType: '',
    location: '',
    isApproved: false,
    isActive: false,
    tags: '',
    businessInfo: '',
  });

  const [submitStatus, setSubmitStatus] = useState('');
  const [isError, setIsError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const config = {
      url: '/businessprofile',
      method: 'post',
      data: formData,
      headers: { Authorization: authState.token }
    };

    try {
      const response = await fetchData(config);

      if (response && response.status) {
        setSubmitStatus('Thank you! Your request has been submitted and is under verification process.');
        setIsError(false);
        setFormData({
          businessName: '',
          businessCode: '',
          contactEmail: '',
          phone: '',
          website: '',
          businessType: '',
          location: '',
          isApproved: false,
          isActive: false,
          tags: '',
          businessInfo: '',
        });
      } else {
        setSubmitStatus('Sorry, we encountered an issue while submitting your deal.');
        setIsError(true);
      }
    } catch (error) {
      console.error('Submit error:', error);
      setSubmitStatus('Something went wrong. Please try again later.');
      setIsError(true);
    }
  };

  return (
    <section id="business" className="py-20 px-4 sm:px-6 md:px-20 bg-blue-200 text-center">
      <h2 className="text-3xl font-bold mb-6 text-pink-700">Are You an Author or Publisher?</h2>
      <p className="text-lg mb-8 max-w-2xl mx-auto text-gray-700">
        WRITZY Provides You an Integrated Tech Ecosystem for Writing & Publishing Immersive Books, Getting Engaged With Readers.
      </p>
      <form onSubmit={handleSubmit} className="max-w-2xl mx-auto bg-white p-6 rounded-lg shadow-md text-left">
        <select name="businessType" value={formData.businessType} onChange={handleChange} className="h-10 mb-4 w-full p-2 border rounded" required>
          <option value="">Select Type</option>
          <option value="Author">Author</option>
          <option value="Publisher">Publisher</option>
        </select>
        <input name="businessName" value={formData.businessName} onChange={handleChange} placeholder="Name" className="mb-4 w-full p-2 border rounded" required />
        <input name="businessCode" value={formData.businessCode} onChange={handleChange} placeholder="Think5Whys Code" className="mb-4 w-full p-2 border rounded" required />
        <textarea name="businessInfo" value={formData.businessInfo} onChange={handleChange} style={{height: "250px"}} placeholder="Personal / Business Info" className="mb-4 w-full p-2 border rounded" required />
        <input name="contactEmail" value={formData.contactEmail} onChange={handleChange} placeholder="Contact Email" type="email" className="mb-4 w-full p-2 border rounded" required />
        <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone" className="mb-4 w-full p-2 border rounded" />
        <input name="website" value={formData.website} onChange={handleChange} placeholder="Website" className="mb-4 w-full p-2 border rounded" />
        <input name="location" value={formData.location} onChange={handleChange} placeholder="Location" className="mb-4 w-full p-2 border rounded" />
        <input name="categories" value={formData.location} onChange={handleChange} placeholder="Book Categories" className="mb-4 w-full p-2 border rounded" />
        <input name="tags" value={formData.tags} onChange={handleChange} placeholder="Keywords" className="mb-4 w-full p-2 border rounded" />
        <button type="submit" className="w-full bg-pink-600 text-white p-2 rounded hover:bg-pink-700 transition">
            Register Yourself
        </button>
        {submitStatus && <p className={`mt-4 ${isError ? 'text-red-600' : 'text-green-600'}`}>{submitStatus}</p>}
      </form>
    </section>
  );
};

export default AuthorProfileForm;
